const duplicateFilters =
	'We have disabled one or more filters within your saved filter because they conflict with the new filters.';
const disabledFilters = 'One or more of the saved filters is turned off';

export { duplicateFilters, disabledFilters };
